var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "popoverElement",
      staticClass: "vfc-popover-container",
      class: [
        _vm.rangeIsSelected ? "range-selected" : "",
        !_vm.rangeIsSelected && _vm.isDisabledDateMouseOver
          ? "disabled-range"
          : "",
        _vm.showMonthPicker || _vm.showYearPicker
          ? "month-year-picker-open"
          : "",
      ],
      attrs: { tabindex: "0" },
    },
    [
      _c("div", { staticClass: "vfc-datepicker-header" }, [
        _vm.$props.isDateRange && false
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputRangeStart,
                    expression: "inputRangeStart",
                  },
                ],
                domProps: { value: _vm.inputRangeStart },
                on: {
                  focusout: function ($event) {
                    return _vm.onInputFocusOut("inputRangeStart", $event)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.inputRangeStart = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputRangeEnd,
                    expression: "inputRangeEnd",
                  },
                ],
                domProps: { value: _vm.inputRangeEnd },
                on: {
                  focusout: function ($event) {
                    return _vm.onInputFocusOut("inputRangeEnd", $event)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.inputRangeEnd = $event.target.value
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$props.isDateRange
          ? _c("div", { staticClass: "vfc-datepicker-header-date" }, [
              _c("div", { staticClass: "vfc-datepicker-header-date-tip" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.placeholderDateRangeTip) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vfc-datepicker-header-date-range" }, [
                _c(
                  "span",
                  {
                    staticClass: "vfc-datepicker-header-date-component",
                    class: _vm.inputRangeStart ? "" : "empty",
                    attrs: { "data-empty": _vm.placeholderDateRangeStart },
                  },
                  [_vm._v(_vm._s(_vm.inputRangeStart))]
                ),
                _vm._v(" "),
                !_vm.sameRangeStartAndEnd
                  ? _c("span", { class: _vm.inputRangeEnd ? "" : "empty" }, [
                      _vm._v(" — "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.sameRangeStartAndEnd
                  ? _c(
                      "span",
                      {
                        staticClass: "vfc-datepicker-header-date-component",
                        class: _vm.inputRangeEnd ? "" : "empty",
                        attrs: { "data-empty": _vm.placeholderDateRangeEnd },
                      },
                      [_vm._v(_vm._s(_vm.inputRangeEnd))]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$props.isDatePicker
          ? _c("div", { staticClass: "vfc-datepicker-header-date" }, [
              _c("div", { staticClass: "vfc-datepicker-header-date-tip" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.placeholderDateTip) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vfc-datepicker-header-date-range" }, [
                _c(
                  "span",
                  {
                    staticClass: "vfc-datepicker-header-date-component",
                    class: _vm.inputDate ? "" : "empty",
                    attrs: { "data-empty": _vm.placeholderDate },
                  },
                  [_vm._v(_vm._s(_vm.inputDate))]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("PickerInputs", {
        attrs: {
          fConfigs: _vm.fConfigs,
          singleSelectedDate: _vm.singleSelectedDate,
          calendar: _vm.calendar,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "dateRangeInputs",
              fn: function (props) {
                return [
                  _vm._t("dateRangeInputs", null, {
                    startDate: props.startDate,
                    endDate: props.endDate,
                    isTypeable: _vm.fConfigs.isTypeable,
                  }),
                ]
              },
            },
            {
              key: "datePickerInput",
              fn: function (props) {
                return [
                  _vm._t("datePickerInput", null, {
                    selectedDate: props.selectedDate,
                    isTypeable: _vm.fConfigs.isTypeable,
                  }),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showCalendar,
              expression: "showCalendar",
            },
          ],
          ref: "mainContainer",
          staticClass: "vfc-main-container",
          class: {
            "vfc-modal":
              _vm.fConfigs.isModal &&
              (_vm.fConfigs.isDatePicker ||
                _vm.fConfigs.isDateRange ||
                _vm.fConfigs.isMultipleDatePicker),
            "vfc-dark": _vm.fConfigs.isDark,
          },
        },
        [
          _vm.showTimePicker
            ? _c("time-picker", {
                ref: "timePicker",
                attrs: { height: _vm.$refs.popoverElement.clientHeight },
              })
            : [
                _c(
                  "div",
                  { staticClass: "vfc-calendars-container" },
                  [
                    _c(
                      "div",
                      { ref: "calendars", staticClass: "vfc-calendars" },
                      _vm._l(_vm.listCalendars, function (calendarItem, key) {
                        return _c(
                          "div",
                          {
                            key: calendarItem.key,
                            staticClass: "vfc-calendar",
                          },
                          [
                            _c("month-year-picker", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showMonthPicker === key + 1 ||
                                    _vm.showYearPicker === key + 1,
                                  expression:
                                    "\n                showMonthPicker === key + 1 || showYearPicker === key + 1\n              ",
                                },
                              ],
                              ref: "monthContainer",
                              refInFor: true,
                              class: "vfc-" + _vm.fConfigs.titlePosition,
                              attrs: {
                                changeYearStep: _vm.changeYearStep,
                                "calendar-key": key,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "vfc-content main-calendar-wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vfc-date-picker-header-navigation",
                                  },
                                  [
                                    _c(
                                      "transition",
                                      {
                                        attrs: {
                                          tag: "div",
                                          name: _vm.getTransition_(),
                                          appear: "",
                                        },
                                      },
                                      [
                                        _vm.checkHiddenElement("month")
                                          ? _c(
                                              "div",
                                              { staticClass: "vfc-top-date" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "vfc-cursor-pointer vfc-underline":
                                                        _vm.fConfigs
                                                          .changeMonthFunction &&
                                                        _vm.isNotSeparatelyAndFirst(
                                                          key
                                                        ),
                                                      "vfc-underline-active":
                                                        _vm.showMonthPicker ===
                                                        key + 1,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        _vm.isNotSeparatelyAndFirst(
                                                          key
                                                        ) &&
                                                          _vm.openMonthPicker(
                                                            key + 1
                                                          )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          calendarItem.month
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "vfc-cursor-pointer vfc-underline":
                                                        _vm.fConfigs
                                                          .changeYearFunction &&
                                                        _vm.isNotSeparatelyAndFirst(
                                                          key
                                                        ),
                                                      "vfc-underline-active":
                                                        _vm.showYearPicker ===
                                                        key + 1,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        _vm.isNotSeparatelyAndFirst(
                                                          key
                                                        ) &&
                                                          _vm.openYearPicker(
                                                            key + 1
                                                          )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          calendarItem.year
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("Arrows", {
                                      attrs: {
                                        isMultiple: false,
                                        fConfigs: _vm.fConfigs,
                                        allowPreDate: _vm.allowPreDate,
                                        allowNextDate: _vm.allowNextDate,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "navigationArrowLeft",
                                            fn: function () {
                                              return [
                                                _vm._t("navigationArrowLeft"),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "navigationArrowRight",
                                            fn: function () {
                                              return [
                                                _vm._t("navigationArrowRight"),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  {
                                    attrs: {
                                      tag: "div",
                                      name: _vm.getTransition_(),
                                      appear: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "vfc-dayNames" },
                                      [
                                        _vm.fConfigs.showWeekNumbers
                                          ? _c("span")
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.fConfigs.dayNames,
                                          function (dayName, dayKey) {
                                            return _c(
                                              "span",
                                              {
                                                key: key + dayKey + 1,
                                                staticClass: "vfc-day",
                                              },
                                              [
                                                _vm.checkHiddenElement(
                                                  "dayNames"
                                                )
                                                  ? [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(dayName) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "transition-group",
                                  {
                                    attrs: {
                                      tag: "div",
                                      name: _vm.getTransition_(),
                                      appear: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        key: "weeks-wrapper",
                                        staticClass: "vfc-weeks-wrapper",
                                      },
                                      _vm._l(
                                        calendarItem.weeks,
                                        function (week, week_key) {
                                          return _c(
                                            "div",
                                            {
                                              key: key + week_key + 1,
                                              staticClass: "vfc-week",
                                            },
                                            [
                                              _vm.showWeekNumbers
                                                ? _c("WeekNumbers", {
                                                    attrs: {
                                                      number: week.number,
                                                      borderColor:
                                                        _vm.borderColor,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._l(
                                                week.days,
                                                function (day, day_key) {
                                                  return _c("Day", {
                                                    key:
                                                      key +
                                                      week_key +
                                                      day_key +
                                                      1,
                                                    ref: "day",
                                                    refInFor: true,
                                                    attrs: {
                                                      isMultipleDateRange:
                                                        _vm.isMultipleDateRange,
                                                      day: day,
                                                      fConfigs: _vm.fConfigs,
                                                      calendar: _vm.calendar,
                                                      helpCalendar:
                                                        _vm.helpCalendar,
                                                      week: week,
                                                      day_key: day_key,
                                                      alwaysUseDefaultClasses:
                                                        _vm.alwaysUseDefaultClasses,
                                                    },
                                                    on: {
                                                      dayMouseOver:
                                                        _vm.dayMouseOver,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (props) {
                                                            return [
                                                              _vm._t(
                                                                "default",
                                                                null,
                                                                {
                                                                  week: props.week,
                                                                  day: props.day,
                                                                }
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  })
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    calendarItem.weeks.length < 6 &&
                                    !_vm.fConfigs.isLayoutExpandable
                                      ? _vm._l(
                                          6 - calendarItem.weeks.length,
                                          function (moreWeekKey) {
                                            return _c(
                                              "div",
                                              {
                                                key:
                                                  key +
                                                  moreWeekKey +
                                                  "moreWeek",
                                                staticClass:
                                                  "vfc-calendar-stabilizer",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                     \n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "vfc-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "vfc-footer-button vfc-footer-button-cancel",
                          attrs: { type: "button" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v(_vm._s(_vm.buttonLabelCancel))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "vfc-footer-button vfc-footer-button-apply",
                          attrs: { type: "button" },
                          on: { click: _vm.onApply },
                        },
                        [_vm._v(_vm._s(_vm.buttonLabelApply))]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canClearRange || _vm.$slots["footer"]
                      ? _c("Footer", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "footer",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { on: { click: _vm.cleanRange } },
                                      [
                                        _vm._t("cleaner", function () {
                                          return [
                                            _vm.canClearRange &&
                                            _vm.fConfigs.isDateRange
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "rangeCleaner",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          _vm.rangeIsSelected
                                                            ? "active"
                                                            : "disabled",
                                                        ],
                                                        on: {
                                                          click: _vm.cleanRange,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Clear Range" +
                                                            _vm._s(
                                                              _vm.isMultipleDateRange &&
                                                                "s"
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        }),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm._t("footer"),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }